import { useEffect, useState } from 'react'
import { SIZE, SHAPE } from 'baseui/button-group';
import { Button } from 'baseui/button';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalButton,
} from 'baseui/modal';
import { IoTrashOutline } from 'react-icons/io5'
import { AccessRoles } from '../../hooks/useHasRole/accessRoles';
import { useHasRole } from '../../hooks/useHasRole';
import { FormattedMessage } from 'react-intl';
import { useDeleteObjectMutation } from '../../services/objects';


const DeleteButton = (props: { dashboardId: string, dashboardName: string, resourceGroupId: string, onDeleted: () => void }) => {
    const {dashboardId, dashboardName, resourceGroupId} = props;
    const hasAccess = useHasRole(AccessRoles.Dashboard.Delete);
    const [isOpen, setIsOpen] = useState(false);
    const [deleteObject, deleteObjectResult] = useDeleteObjectMutation();

    const handleDeleteClick = (e: any) => { deleteObject({ id: dashboardId, resourceGroupId: resourceGroupId }); setIsOpen(false) }
    const handleClose = () => setIsOpen(false);

    useEffect(() => { if (deleteObjectResult.isSuccess) props.onDeleted(); },[deleteObjectResult])

    return (
        <>
            <Button shape={SHAPE.round} kind="tertiary" size='compact' disabled={!hasAccess} onClick={() => setIsOpen(true)} isLoading={deleteObjectResult.isLoading}><IoTrashOutline /></Button>
            <Modal onClose={handleClose} isOpen={isOpen}>
                <ModalHeader><FormattedMessage id='Dashboard.DeleteDialogTitle' defaultMessage='Delete Dashboard' /></ModalHeader>
                <ModalBody>
                    <FormattedMessage id='Dashboard.DeleteDialogText' defaultMessage='Do you really want to delete {name}?'
                        values={
                            { name: <b>{dashboardName}</b> }
                        } />
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={handleClose}>
                        <FormattedMessage id='cancel' defaultMessage='Cancel' />
                    </ModalButton>
                    <ModalButton onClick={handleDeleteClick} isLoading={deleteObjectResult.isLoading}><FormattedMessage id='ok' defaultMessage='Ok' /></ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default DeleteButton;